import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InitState {
  number: number;
}

const initialState: InitState = {
  number: 0,
};

const agentManageSlice = createSlice({
  name: 'agentmanage',
  initialState,
  reducers: {
    changeCount: (state = initialState, action: PayloadAction<number>) => {
      state.number = action.payload;
    },
  },
});

export const { changeCount } = agentManageSlice.actions;
export default agentManageSlice.reducer;
